//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.OperationBuilder.js";
import "../CAM/CAM.InspectionCylinderCircleFitModeBuilder.js";
import "../CAM/CAM.InspectionFeatureDataFilterBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
import "../no/SelectNXObject.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CenterPointX",1,0],[0,"CenterPointY",1,0],[0,"CenterPointZ",1,0],[0,"CsysRefType",1,0],[1,"CylinderCircleFitModeBuilder",0,"CAM.InspectionCylinderCircleFitModeBuilder",0],[1,"DataFilterBuilder",0,"CAM.InspectionFeatureDataFilterBuilder",0],[0,"Diameter",1,0],[0,"InnerOuterType",1,0],[0,"Name",1,0],[0,"NormalVectorI",1,0],[0,"NormalVectorJ",1,0],[0,"NormalVectorK",1,0],[1,"OffsetDistance",0,"CAM.InheritableDoubleBuilder",0],[0,"ReverseDirection",1,0],[1,"SelectProjectionFaces",0,"SelectNXObject",0],[1,"SelectedCircle",0,"SelectNXObjectList",0]],[[[],"UpdateParams",{},0,0],[[],"FlipNormal",{},0,0],[[],"UpdateOffset",{},0,0],[[],"ReverseOffsetDirection",{},0,0]],[]];
SPLM.CAM.InspectionCircleFeatureBuilder = class extends SPLM.CAM.OperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionCircleFeatureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;